import { formatNumber } from '@utils/formatNumber';

/** Above this a percentage only says "far above plan" (a few work days against
 *  a large plan), so the display stops counting. The value itself is untouched. */
const DISPLAY_CEILING_PCT = 999;

/**
 * A productivity-style percentage for display, or an em dash when it could not
 * be computed.
 */
export function formatPercentCell(value: number | null): string {
  if (value === null) return '—';
  return value > DISPLAY_CEILING_PCT ? `${formatNumber(DISPLAY_CEILING_PCT)}%+` : `${formatNumber(value)}%`;
}